export default {
  /**
   * @description 配置显示在浏览器标签的title
   */
  title: 'empower',
  /**
   * @description 是否使用国际化，默认为false
   *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
   *              用来在菜单中显示文字
   */
  useI18n: true,
  /**
   * @description api请求基础路径
   */
  baseUrl: {
    dev: 'https://dapp.tiktokt.xyz/api/',
    pro: ''
  },


  /**
   * @param Server 上传到服务器
   * @param Oss 上传到阿里云oss
   * @param QiNiu 七牛云
   * @description 文件上传设置
   */
  uploadMethod: 'Oss',
  /**
   * @param string folder
   * @description 默认上传的主目录信息
   */
  folder: 'upload',
  /**
   * @description 需要加载的插件
   */
  plugin: {}
}
